export default "__VITE_ASSET__Bc8Nx72G__"